<a href="mailto:info@ag-grid.com"  class="button-secondary">
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 32 32">
      <path d="M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z" transform="translate(0)"/>
  </svg>

  {{ buttonText }}
</a>